/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaOperatoreDetailDTO } from '../model/models';
import { PraticaExportTabularFilter } from '../model/models';
import { PraticaExportZipFilter } from '../model/models';
import { PraticaPdfRigeneraDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DownloadPraticaPdfOriginaleRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface ExportPraticheTabularRequestParams {
    idTipoPratica: string;
    filter: PraticaExportTabularFilter;
    pageable: Pageable;
}

export interface ExportPraticheZipRequestParams {
    idTipoPratica: string;
    filter: PraticaExportZipFilter;
}

export interface RigeneraPraticaPdfRequestParams {
    idTipoPratica: string;
    idPratica: string;
    version: number;
}


export interface GestionePratichePDFExportServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Scarica il PDF originale della pratica (autocertificazione ex D.P.R. 445/2000 sottoscritta dal richiedente). Capability CONSULTAZIONE (lettura). R1 cross-tipo applicato dal service; 404 anche se il PDF non e\&#39; ancora stato generato per questa pratica.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/pdf-originale/download
* @param requestParameters
     */
    downloadPraticaPdfOriginale(requestParameters: DownloadPraticaPdfOriginaleRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Export tabellare (dati, non file) delle pratiche del bando per il consumo dell\&#39;export Excel client-side del FE. Capability CONSULTAZIONE (lettura, parity export-zip/list 10.f). Body: Page&lt;{summary, form_data}&gt; — la riga e\&#39; la stessa forma del detail operatore (chiavi form_data &#x3D; TipoPraticaAttributo.chiave del bando, incluse le sezioni anagrafica e nucleo[]). Filtro stato override-able via ?stato (multi-select raw, comma-separated); default &#x3D; TUTTE le pratiche del bando (nessun filtro stato); token invalido → 422 gestione_pratica_filter_stato_invalido. Niente importo_riconosciuto/redistribuito (concetti di dominio non modellati).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/export-tabular
* @param requestParameters
     */
    exportPraticheTabular(requestParameters: ExportPraticheTabularRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaOperatoreDetailDTO>;

    /**
     * Export ZIP delle pratiche del bando filtrate per stato. Capability CONSULTAZIONE (lettura). Filtro stato override-able via ?stato (multi-select raw, comma-separated); default {RICHIESTA_RIFIUTATA, RICHIESTA_ACCETTATA, VOUCHER_ASSEGNATI, VOUCHER_CONSEGNATI}; token invalido → 422 gestione_pratica_filter_stato_invalido. Struttura: 1 sub-folder per pratica ({codice}/) con allegati persistiti as-is + _stato.txt (staleness). Streaming memory-bound; errori S3 mid-stream best-effort.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/export-zip
* @param requestParameters
     */
    exportPraticheZip(requestParameters: ExportPraticheZipRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Rigenera on-demand il PDF originale della pratica coi dati live delle entity native, upsert in-place sul PDF_PRATICA_ORIGINALE. Capability GESTIONE (mutazione). Gate: R1 cross-tipo (404), R2 @Version (409), G1 bando in lavorazione (422), G2 pratica editabile (422). Response: 200 + {version} aggiornata.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/rigenera-pdf
* @param requestParameters
     */
    rigeneraPraticaPdf(requestParameters: RigeneraPraticaPdfRequestParams, extraHttpRequestParams?: any): Observable<PraticaPdfRigeneraDTO>;

}
